import React from 'react';
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import Page from "../../Components/Page";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import EditableReactTableV2 from "../../Components/ReactTable/EditableReactTableV2";
import {EditFormTextInputField} from "../../Components/ReactTable/EditRecordForm";

const BrowseNodes = () => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/browseNodes/`
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    const customColumns = [
        {header: "Value", accessorKey: "value"},
        {header: "Label", accessorKey: "label"},
    ]

    return (<Page name={"Browse Nodes"}>
        <LoadingWrapper loading={loading}>
            <EditableReactTableV2
                filterable
                data={data.data}
                columns={customColumns}
                editTable={[
                    {id: "index", Component: args => <EditFormTextInputField  {...args} disabled label={"Index"}/>},
                    {id: "value", Component: args => <EditFormTextInputField  {...args} isRequired label={"Value"}/>},
                    {id: "label", Component: args => <EditFormTextInputField  {...args} isRequired label={"Label"}/>},
                ]}
                onRowEditConfirmed={onRowEditConfirmed}
                onRowDeleteConfirmed={onRowDeleteConfirmed}
            />
        </LoadingWrapper>
    </Page>);
};

export default BrowseNodes;